import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MapView = _resolveComponent("MapView")!
  const _component_SearchBar = _resolveComponent("SearchBar")!
  const _component_MyLocationBtn = _resolveComponent("MyLocationBtn")!
  const _component_TripDetails = _resolveComponent("TripDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MapView),
    _createVNode(_component_SearchBar),
    _createVNode(_component_MyLocationBtn),
    _createVNode(_component_TripDetails)
  ], 64))
}